//表单数据
export const formData = {
    newsId:'',
    houseId: '',
    title: '',
    remark: '',
    pic: '',
    content: '',
    sort: ''
}

//表单验证规则
export const formRules = {
    houseId: [{ required: true, message: "楼盘不能为空", trigger: "blur" }],
    title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
    //pic: [{ required: true, message: "图片不能为空", trigger: "blur" }],
    content: [{ required: true, message: "正文不能为空", trigger: "blur" }],
    sort: [{ required: true, message: "排序不能为空", trigger: "blur" }]
}